// This config file maps Content Types from Contentful
// to more user friendly Page Types.

const contentTypeMap = {
  ContentfulHomePage: 'homePage',
  ContentfulCircularExamplePage: 'circularExamplePage',
  ContentfulStandardPage: 'standardPage',
  ContentfulSubPage: 'subPage',
  ContentfulResource: 'resource',
  ContentfulWebflowPage: 'webflowPage',
};

module.exports = {
  contentTypeMap,
};
